import { PictureNameLineProps } from './picture-name-line.types'
import styles from './picture-name-line.module.scss'
import cl from 'classnames'
import { ImagePortrait, Text1 } from '@touche-lts/panel-ui/dist'

const PictureNameLineComponent = (props: PictureNameLineProps) => {
  const {
    className,
    style,
    imagePortraitProps,
    name,
    nameTextProps,
    imageSrc,
    noImagePreset = 'picture',
    imageBoxShadow
  } = props

  const imgSrc = imageSrc || (noImagePreset === 'person' ? undefined : null)

  return (
    <div className={cl(styles.container, className)} style={style}>
      <ImagePortrait
        src={imgSrc}
        width={23.8}
        className={cl(styles.image, {
          [styles.imageBoxShadow]: imageBoxShadow
        })}
        {...imagePortraitProps}
      />
      <Text1
        bold
        overflowEllipsis
        style={{ marginLeft: 16 }}
        {...nameTextProps}
      >
        {name}
      </Text1>
    </div>
  )
}

const PictureNameLine = PictureNameLineComponent
export { PictureNameLine }
